/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { Stack, StackProps, Typography } from '@mui/material';
import React, { FC } from 'react';

import BrandLogo from './BrandLogo';

/**
 * Brand
 */
const Brand: FC<StackProps> = (props) => {
  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      spacing={1.75}
      sx={{ typography: 'h4', color: 'dark.900', userSelect: 'none' }}
      {...props}
    >
      <Stack alignItems="center" justifyContent="center" flexGrow={0} flexShrink={0}>
        <BrandLogo />
      </Stack>

      <Stack
        flexGrow={1}
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ overflow: 'hidden' }}
      >
        <Typography component="h1" sx={{ fontSize: 22, fontWeight: 500 }}>
          Suppliers
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Brand;
